import React from 'react';
import Icon from "../../Icon";
import SelectRectangleBlock from "./SelectRectangleBlock";
// 0 =>non defini // 1=>femmehetero, 2=>femmelesbienne, 3=>femmebi, 4=>hommehetero, 5=>hommegay, 6=>hommebi, 7=>couplehetero, 8=>Couple homo, 9=>Couple lesbien, 10=>couplefemmeb, 11=>couplehommebi, 12=>travtrans
const ChooseGender = [
    {name: "hétéro", value: 4},
    {name: "bi", value: 6},
    {name: "homo", value: 5},
    {name: "hétéro", value: 1},
    {name: "bi", value: 3},
    {name: "homo", value: 2},
    {name: "hétéro", value: 7},
    {name: "lesbiennes", value: 9},
    {name: "gay", value: 8},
    {name: "femme bi", value: 10},
    {name: "homme bi", value: 11},
    {name: "trav / trans", value: 12}
];

const AskLookingFor = (props) => {
    return (
        <div id={"askLookingFor"}>
            <div className={"column"}>
                <span className={"lookfor-title"}>
                    <Icon type={"mars"}/>
                    <span className={"lookfor-title"}>Homme</span>
                </span>
                <div className={"lookingFor-options"}>
                    {ChooseGender.slice(0, 3).map((item, index) => (
                        <SelectRectangleBlock key={index} isActive={props.lookingFor.includes(item.value)}
                                              onClick={() => props.handleBlockSelection(item.value, "lookingFor")}>
                            {item.name}
                        </SelectRectangleBlock>
                    ))}
                </div>
            </div>
            <div className={"column"}>
                <span className={"lookfor-title"}>
                    <Icon type={"venus"}/>
                    <span className={"lookfor-title"}>Femme</span>
                </span>
                <div className={"lookingFor-options"}>
                    {ChooseGender.slice(3, 6).map((item, index) => (
                        <SelectRectangleBlock key={index} isActive={props.lookingFor.includes(item.value)}
                                              onClick={() => props.handleBlockSelection(item.value, "lookingFor")}>
                            {item.name}
                        </SelectRectangleBlock>
                    ))}
                </div>
            </div>
            <div className={"column"}>
                <span className={"lookfor-title"}>
                    <Icon type={"venus-mars"}/>
                    <span className={"lookfor-title"}>Couple</span>
                </span>
                <div className={"lookingFor-options"}>
                    {ChooseGender.slice(6, 11).map((item, index) => (
                        <SelectRectangleBlock key={index} isActive={props.lookingFor.includes(item.value)}
                                              onClick={() => props.handleBlockSelection(item.value, "lookingFor")}>
                            {item.name}
                        </SelectRectangleBlock>
                    ))}
                </div>
            </div>
            <div className={"column"}>
                <span className={"lookfor-title"}>
                    <Icon type={"transgender"}/>
                    <span className={"lookfor-title"}>Autre</span>
                </span>
                <div className={"lookingFor-options"}>
                    {ChooseGender.slice(11, 12).map((item, index) => (
                        <SelectRectangleBlock key={index} isActive={props.lookingFor.includes(item.value)}
                                              onClick={() => props.handleBlockSelection(item.value, "lookingFor")}>
                            {item.name}
                        </SelectRectangleBlock>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default AskLookingFor;